import React from "react";
import Layout from "./header_footer/Layout";
import Jumbotron from "./utils/Jumbotron";

export default function Termos() {
  return (
    <Layout>
      <Jumbotron title={"Termos e Condições"}></Jumbotron>

      <div className="container">
        <div className="row terms-container">
          <div className="terms">
            <h3 className="terms-title">Recolha e Armazenamento de dados</h3>
            <p className="terms-text">
              Os dados pessoais identificados no Formulário de inscrição em um
              evento, são indispensáveis à prestação dos serviços pela Junta de
              Freguesia do Sabugueiro. Os dados recolhidos nesse formulário
              serão armazenados informáticamente, não sendo partilhados em
              nenhuma altura ou por nenhum motivo com alguma entidade externa à
              Junta de Freguesia do Sabugueiro. Estes dados irão ser armazenados
              em base de dados durante o máximo de 6(seis) meses após a
              realização do evento.
            </p>

            <h3 className="terms-title">Reserva em eventos</h3>
            <p className="terms-text">
              Para a inscrição num evento pago ficar concluída, o cliente deve
              enviar o comprovativo de pagamento da inscrição através dos meios
              indicados aquando da reserva. Apenas após esse envio e posterior
              validação do pagamento, a inscrição é considerada válida. No dia
              de realização do evento, deve fazer-se acompanhar do email de
              validação, recebido após a validação do comprovativo de pagamento
              por parte da Junta de Freguesia.
            </p>

            <h3 className="terms-title">Cancelamento de evento</h3>
            <p className="terms-text">
              A Junta de Freguesia do Sabugueiro reserva o direito de cancelar
              um evento agendado, sem aviso prévio, a qualquer data da
              realização de um evento. Caso um evento seja cancelado, irá ser
              efetuada a devolução do valor da inscrição de cada inscrito, pelo
              mesmo meio do pagamento da inscrição.
            </p>

            <h3 className="terms-title">Cancelamento da Inscrição</h3>
            <p className="terms-text">
              A Junta de Freguesia do Sabugueiro dá o direito ao cancelamento de
              uma inscrição num evento, 15 dias após a submissão da inscrição.
              Para isso, deve ser efetuada uma resposta ao e-mail de validação
              da inscrição, referindo que deseja cancelar a sua inscrição no
              evento. Caso o pedido de cancelamento esteja dentro do prazo de 15
              dias, será efetuada a devolução do valor da inscrição pelo mesmo
              meio de pagamento. Caso pretenda cancelar uma inscrição, e se
              encontre fora dos 15 dias de cancelamento, deve entrar em contacto
              com a Junta de Freguesia do Sabugueiro através do email de
              validação recebido, onde o pedido de cancelamente será avaliado,
              e, caso aprovado, o valor da inscrição será devolvido.
            </p>
          </div>
        </div>
      </div>
      <h3></h3>
    </Layout>
  );
}
